import type { PlayerData } from '@/types';

interface PlayerStatusProps {
  player: PlayerData;
}

export const PlayerStatus = ({ player }: PlayerStatusProps) => {
  return (
    <div className="section">
      <div className="label">Statut</div>
      <div className="flex items-center gap-2">
        <span
          className={`w-2 h-2 rounded-full ${
            player.banned ? 'bg-red-500' : 'bg-green-500'
          }`}
        ></span>
        <span className="value">
          {player.banned ? 'Banni' : 'Actif'}
        </span>
      </div>
    </div>
  );
};
